import {Component, Input, OnInit} from '@angular/core';
import {IPost} from '../data.service';

@Component({
  selector: 'app-publication-item',
  templateUrl: './publication-item.component.html',
  styleUrls: ['./publication-item.component.scss']
})
export class PublicationItemComponent implements OnInit {

  data: IPost;
  @Input() itemData: IPost;
  @Input() moreLabel: string;
  @Input() showDescription = false;
  @Input() square = false;

  constructor() {
    this.data = {
      src: '',
      alt: '',
      title: '',
      description: '',
      link: null,
      position: ''
    };
  }

  ngOnInit(): void {
    this.data = {...this.itemData};
  }

}
